skrilla.controller('createTestReportModal', function ($scope, $q, searchService, cacheService, srefService, modalService) {
    searchService.get("reports/reportKeys").then(function(response){
        $scope.keys = response.data;
    });
    $scope.request = {};

    $scope.create = function(){
        console.log($scope.request)
        modalService.confirm("Are you sure you'd like to create a test report?", function(){
            searchService.post(`reports/test`, $scope.request, "Success", true).then(function(response){
                modalService.dismissAll();
                srefService.go("reportDetails", {id: response.data})
            })
        })
    }

});

